export const FIA_FEDERAL_OFFENCES_CASE_TAXONOMY_CONFIG = {
  id: 'fia_cybercrime_federal_offences',
  label: 'FIA / Cybercrime / Federal Offences',
  shortLabel: 'FIA',
  description: 'FIA inquiries, investigations, cybercrime/PECA matters, electronic fraud, human trafficking, migrant smuggling, immigration/passport matters, AML, FIA challans/trials, bail, remand, appeals, constitutional challenges, and related federal offence proceedings.',
  active: true,
  types: [
    {
      id: 'FIA Inquiry / Notice Matter',
      label: 'FIA Inquiry / Notice Matter',
      shortLabel: 'Inquiry / Notice',
      description: 'Pre-FIR or pre-challan FIA inquiry matters, including notice, summons, complaint verification, document production, cybercrime complaint response, and representation before FIA.',
      legalBasis: [
        'Federal Investigation Agency Act, 1974.',
        'CrPC, where applicable.',
        'PECA 2016, where cybercrime/electronic crime is involved.',
        'AMLA 2010, where money laundering/financial crime is involved.',
        'Relevant special law depending on FIA wing/matter.',
        'Challenge to illegal notice/inquiry may be through constitutional jurisdiction where maintainable.'
      ],
      subtypes: [
        'FIA Notice',
        'FIA Inquiry Notice',
        'Summons / Appearance Notice',
        'Document Production Notice',
        'Cybercrime Complaint Verification',
        'Complaint Response / Representation',
        'Inquiry Closure Request',
        'Protection Against Harassment',
        'Other FIA Inquiry Matter'
      ],
      sideOptions: ['Notice Recipient / Accused', 'Complainant', 'Witness', 'FIA / Prosecution', 'Affected Person', 'Applicant', 'Respondent'],
      defaultStages: [
        'Notice / Complaint Review',
        'Record Collection',
        'Reply / Representation Drafting',
        'Submission to FIA',
        'Personal Appearance, if required',
        'Further Documents / Questionnaire, if any',
        'Inquiry Proceedings / Verification',
        'Inquiry Closure / FIR Registration / Investigation / Further Action',
        'Constitutional Challenge, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Regional Office / Circle', description: 'Common forum for FIA notice response, inquiry appearance, and document production.', isRecommended: true },
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: 'Use for cybercrime/PECA complaint verification or inquiry.', isRecommended: false },
        { label: 'FIA Anti-Money Laundering / Financial Crime Wing', description: 'Use for AML/financial crime inquiry.', isRecommended: false },
        { label: 'FIA Anti-Human Trafficking Circle', description: 'Use for trafficking, migrant smuggling, or travel agent fraud inquiry.', isRecommended: false },
        { label: 'FIA Immigration Wing', description: 'Use for passport/immigration/ECL/offloading inquiry.', isRecommended: false },
        { label: 'High Court / Constitutional Jurisdiction', description: 'Use where FIA notice/inquiry is challenged by writ where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Inquiry forum depends on FIA wing, notice issuing authority, offence type, complaint stage, and maintainability of challenge.',
      documentTabs: [
        'FIA Notice / Inquiry',
        'Reply / Representation',
        'Documents Submitted',
        'FIA Correspondence',
        'Digital / Financial Record',
        'Orders / Directions',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Investigation Matter',
      label: 'FIA Investigation Matter',
      shortLabel: 'Investigation',
      description: 'FIA investigation stage matters after FIR/complaint registration or formal investigation, including summons, statements, document production, device/data seizure, arrest apprehension, and investigation challenge.',
      legalBasis: [
        'FIA Act, 1974.',
        'CrPC investigation/remand/search/seizure framework where applicable.',
        'PECA 2016 for cybercrime investigation.',
        'AMLA 2010 for money laundering investigation.',
        'Applicable special law depending offence.'
      ],
      subtypes: [
        'Investigation Notice',
        'Summons / Appearance',
        'Statement before FIA',
        'Document Production during Investigation',
        'Device / Data Seizure',
        'Arrest Apprehension',
        'Investigation Closure Request',
        'Challenge to Investigation',
        'Other FIA Investigation Matter'
      ],
      sideOptions: ['Accused / Suspect', 'Complainant', 'Witness', 'FIA / Prosecution', 'Affected Person', 'Applicant', 'Respondent'],
      defaultStages: [
        'FIR / Investigation Notice Review',
        'Record / Digital Evidence Collection',
        'Statement / Reply Preparation',
        'Appearance before FIA',
        'Document / Device Production',
        'Seizure / Forensic Examination, if any',
        'Further Investigation / Follow-up Notices',
        'Arrest Apprehension / Bail Strategy, if any',
        'Investigation Closure / Challan / Further Action',
        'Constitutional Challenge, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Regional Office / Circle', description: 'Common forum for FIA investigation summons, statements, document production, and cooperation.', isRecommended: true },
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: 'Use for PECA/cybercrime investigation.', isRecommended: false },
        { label: 'FIA Anti-Money Laundering / Financial Crime Wing', description: 'Use for AML/financial investigation.', isRecommended: false },
        { label: 'FIA Anti-Human Trafficking Circle', description: 'Use for trafficking/smuggling investigation.', isRecommended: false },
        { label: 'FIA Immigration Wing', description: 'Use for immigration/passport investigation.', isRecommended: false },
        { label: 'Magistrate / Special Magistrate', description: 'Use for production/remand/search/seizure matters where applicable.', isRecommended: false },
        { label: 'High Court', description: 'Use for pre-arrest/protective bail or investigation challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Investigation forum depends on FIA wing, FIR/complaint status, offence type, seizure/arrest issue, and court intervention.',
      documentTabs: [
        'Investigation Notice / Summons',
        'Statements / Replies',
        'Documents Submitted',
        'Device / Data Record',
        'FIA Correspondence',
        'Applications / Challenges',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Cybercrime / PECA Matter',
      label: 'Cybercrime / PECA Matter',
      shortLabel: 'Cybercrime / PECA',
      description: 'Matters under cybercrime/electronic crime law, including unauthorized access, cyber harassment, cyberstalking, identity misuse, online defamation, electronic forgery, electronic fraud, malicious code, data/device offences, and online content-related offences.',
      legalBasis: [
        'Prevention of Electronic Crimes Act, 2016.',
        'PECA covers offences relating to information systems, data, unauthorized access/copying, interference, electronic fraud/forgery, identity offences, cyberstalking/harassment, and investigation/trial mechanisms.',
        'CrPC and QSO may apply where relevant.',
        'Platform/regulator/takedown process may be relevant depending facts.'
      ],
      subtypes: [
        'Unauthorized Access / Hacking',
        'Unauthorized Copying / Transmission of Data',
        'Cyber Harassment',
        'Cyberstalking',
        'Online Defamation / Reputation Harm',
        'Identity Misuse / Impersonation',
        'Misuse of Intimate Images / Privacy Violation',
        'Electronic Forgery',
        'Malicious Code / Malware',
        'Unauthorized SIM / Identity Use',
        'Social Media Complaint',
        'Online Threats / Blackmail',
        'Other PECA / Cybercrime Matter'
      ],
      sideOptions: ['Accused', 'Complainant', 'Victim / Affected Person', 'FIA / Prosecution', 'Platform / Service Provider', 'Applicant', 'Respondent'],
      defaultStages: [
        'Complaint / Allegation Review',
        'Digital Evidence Preservation',
        'FIA Complaint / Inquiry',
        'Notice / Summons / Appearance',
        'Investigation / Device or Data Examination',
        'FIR Registration / Challan, if any',
        'Bail / Remand, if required',
        'Trial Proceedings, if challan filed',
        'Arguments / Order / Judgment',
        'Appeal / Writ / Further Remedy, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: 'Primary FIA forum for cybercrime/PECA complaints, inquiry, and investigation.', isRecommended: true },
        { label: 'Special Court / Cybercrime Court', description: 'Use for trial/challan under PECA or assigned cybercrime court.', isRecommended: false },
        { label: 'Magistrate / Special Magistrate', description: 'Use for remand/search/seizure/production where applicable.', isRecommended: false },
        { label: 'High Court', description: 'Use for bail, quashment, writ, or constitutional challenge where maintainable.', isRecommended: false },
        { label: 'Regulator / Bank / Platform Complaint Forum', description: 'Use where social media platform, telecom, bank, or digital platform process is relevant.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Cybercrime forum depends on PECA offence, complaint/investigation/trial stage, device/data issue, platform involvement, and available remedy.',
      documentTabs: [
        'Cybercrime Complaint / Defence',
        'Digital Evidence',
        'Device / Forensic Record',
        'FIA Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Electronic Fraud / Financial Cybercrime',
      label: 'Electronic Fraud / Financial Cybercrime',
      shortLabel: 'Electronic Fraud',
      description: 'Cyber-enabled financial fraud matters including online banking fraud, card fraud, mobile wallet fraud, phishing, OTP fraud, investment scam, e-commerce fraud, payment fraud, and digital financial deception.',
      legalBasis: [
        'PECA 2016 electronic fraud/forgery/unauthorized access context.',
        'PPC/CrPC where fraud/cheating/forgery applies.',
        'Banking/wallet/regulator process may be relevant.',
        'AMLA may be relevant where proceeds of crime / layering / suspicious transactions are involved.'
      ],
      subtypes: [
        'Online Banking Fraud',
        'Debit / Credit Card Fraud',
        'Mobile Wallet / Easypaisa / JazzCash Fraud',
        'Phishing / OTP Fraud',
        'E-Commerce Fraud',
        'Fake Investment / Trading Scam',
        'Cryptocurrency / Digital Asset Scam',
        'Payment Gateway Fraud',
        'Business Email Compromise',
        'Other Electronic Fraud'
      ],
      sideOptions: ['Complainant / Victim', 'Accused / Suspect', 'Bank / Financial Institution', 'Wallet Provider', 'FIA / Prosecution', 'Applicant', 'Respondent'],
      defaultStages: [
        'Fraud / Transaction Review',
        'Digital and Transaction Evidence Collection',
        'Bank / Wallet Complaint',
        'FIA Complaint / Inquiry',
        'Investigation / Account Trace',
        'Freezing / Recovery Request, if any',
        'FIR / Challan / Trial, if any',
        'Bail / Remand, if required',
        'Order / Recovery / Closure',
        'Further Remedy, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: 'Common forum for electronic fraud/cyber-enabled financial complaint.', isRecommended: true },
        { label: 'FIA Anti-Money Laundering / Financial Crime Wing', description: 'Use where money laundering/proceeds of crime or financial trail investigation is involved.', isRecommended: false },
        { label: 'Bank / Wallet Provider / Regulator Complaint Forum', description: 'Use for bank, payment provider, mobile wallet, or regulator complaint process.', isRecommended: false },
        { label: 'Special Court / Cybercrime Court', description: 'Use for PECA challan/trial.', isRecommended: false },
        { label: 'High Court', description: 'Use for bail, writ, quashment, account freezing challenge, or other challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Electronic fraud forum depends on platform, transaction trail, bank/wallet involvement, PECA/FIR status, and whether AML/financial investigation is involved.',
      documentTabs: [
        'Fraud Complaint / Defence',
        'Transaction Record',
        'Digital Evidence',
        'Bank / Wallet Record',
        'FIA Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Human Trafficking / Migrant Smuggling Matter',
      label: 'Human Trafficking / Migrant Smuggling Matter',
      shortLabel: 'Trafficking / Smuggling',
      description: 'FIA matters relating to human trafficking, migrant smuggling, illegal recruitment, travel agent fraud, forged travel documents, illegal immigration facilitation, exploitation, and cross-border movement offences.',
      legalBasis: [
        'Prevention of Trafficking in Persons Act, 2018.',
        'Prevention of Smuggling of Migrants Act, 2018.',
        'Emigration Ordinance, 1979 where overseas employment/travel agent context applies.',
        'Passport/Foreigners/Immigration laws may be relevant.',
        'CrPC/PPC may apply where relevant.'
      ],
      subtypes: [
        'Human Trafficking',
        'Migrant Smuggling',
        'Illegal Recruitment / Overseas Employment Fraud',
        'Travel Agent Fraud',
        'Forged Travel Documents',
        'Illegal Immigration Facilitation',
        'Deportee / Returnee Matter',
        'Visa / Work Permit Fraud',
        'Border / Airport Interception',
        'Other Trafficking / Smuggling Matter'
      ],
      sideOptions: ['Accused', 'Victim / Complainant', 'Travel Agent', 'FIA / Prosecution', 'Deportee / Returnee', 'Applicant', 'Respondent'],
      defaultStages: [
        'Complaint / FIR Review',
        'Travel and Payment Record Collection',
        'FIA Inquiry / Investigation',
        'Arrest / Bail / Remand, if any',
        'Challan / Trial, if any',
        'Prosecution Evidence',
        'Defence Evidence / Cross-Examination',
        'Arguments',
        'Judgment / Order',
        'Appeal / Writ / Further Remedy, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Anti-Human Trafficking Circle', description: 'Primary FIA forum for trafficking, migrant smuggling, illegal recruitment, and travel agent fraud matters.', isRecommended: true },
        { label: 'Special Court / FIA Court', description: 'Use for trial/challan under relevant FIA/special law.', isRecommended: false },
        { label: 'Magistrate / Special Magistrate', description: 'Use for remand/production where applicable.', isRecommended: false },
        { label: 'High Court', description: 'Use for bail, quashment, writ, or constitutional challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Trafficking/smuggling forum depends on offence type, FIA circle, victim/accused status, FIR/challan stage, and applicable special law.',
      documentTabs: [
        'Complaint / FIR / Defence',
        'Travel / Immigration Record',
        'Payment / Agent Record',
        'FIA Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Immigration / Passport / Exit Control Matter',
      label: 'Immigration / Passport / Exit Control Matter',
      shortLabel: 'Immigration / Passport',
      description: 'FIA and federal matters relating to immigration control, passport offences, exit/entry restrictions, airport interception, deportation, blacklisting, visa fraud, ECL/PNIL issues, and travel document matters.',
      legalBasis: [
        'Passport Act / passport rules where applicable.',
        'Exit from Pakistan Control Ordinance / Rules for ECL matters.',
        'Foreigners Act / immigration laws where applicable.',
        'FIA Act / CrPC where FIA investigation or prosecution is involved.',
        'Constitutional jurisdiction may be relevant for ECL/PNIL/offloading/travel restriction.'
      ],
      subtypes: [
        'Passport Offence',
        'Fake / Forged Passport',
        'Visa Fraud',
        'Airport Offloading / Interception',
        'Deportation / Returnee Matter',
        'Exit Control List / ECL',
        'Provisional National Identification List / PNIL',
        'Blacklisting / Travel Restriction',
        'Foreigners Registration / Stay Issue',
        'Other Immigration / Passport Matter'
      ],
      sideOptions: ['Applicant / Traveler', 'Accused', 'FIA / Immigration Authority', 'Passport Authority', 'Federal Government', 'Complainant', 'Respondent'],
      defaultStages: [
        'Travel / Restriction Record Review',
        'Authority / FIA Representation',
        'Petition / Application Drafting',
        'Filing before Forum',
        'Notice to Authority / Respondents',
        'Comments / Report',
        'Interim Relief / Travel Permission, if any',
        'Arguments',
        'Order / Direction',
        'Compliance / Removal / Further Remedy',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Immigration Wing', description: 'Primary forum/authority for immigration/passport/offloading matters where FIA is involved.', isRecommended: true },
        { label: 'Passport Authority / Directorate', description: 'Use where passport issuance/cancellation/record issue is involved.', isRecommended: false },
        { label: 'Federal Government / Ministry', description: 'Use where ECL/PNIL/blacklisting/travel restriction is administrative/federal decision.', isRecommended: false },
        { label: 'Special Court / Immigration / Passport Court', description: 'Use for passport/immigration offence trial where assigned.', isRecommended: false },
        { label: 'High Court / Constitutional Jurisdiction', description: 'Use for ECL/PNIL/offloading/blacklisting/travel restriction challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Immigration/passport forum depends on whether the issue is criminal prosecution, administrative travel restriction, passport record, airport action, or writ challenge.',
      documentTabs: [
        'Immigration / Passport Petition',
        'Travel Documents',
        'FIA / Authority Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Anti-Money Laundering Matter',
      label: 'Anti-Money Laundering Matter',
      shortLabel: 'AML',
      description: 'FIA-related anti-money laundering matters involving proceeds of crime, suspicious transactions, bank account freezing, financial investigation, asset tracing, predicate offences, and AML prosecution/defence.',
      legalBasis: [
        'Anti-Money Laundering Act, 2010.',
        'Predicate offence linkage.',
        'Suspicious transaction / financial monitoring context.',
        'Account freezing/attachment and proceeds of crime issues.',
        'CrPC/QSO where applicable.',
        'FIA financial crime/AML investigation where applicable.'
      ],
      subtypes: [
        'AML Inquiry / Investigation',
        'Suspicious Transaction / STR Matter',
        'Bank Account Freezing',
        'Proceeds of Crime Allegation',
        'Predicate Offence Linked AML',
        'Asset Tracing / Attachment',
        'AML Challan / Trial',
        'AML Bail',
        'AML Appeal / Challenge',
        'Other AML Matter'
      ],
      sideOptions: ['Accused / Suspect', 'Account Holder', 'Third-Party Claimant', 'FIA / Prosecution', 'Bank / Financial Institution', 'Applicant', 'Respondent'],
      defaultStages: [
        'AML Allegation / Predicate Offence Review',
        'Financial Record Collection',
        'FIA / Bank / Regulator Inquiry',
        'Account Freezing / Attachment, if any',
        'Bail / Remand, if required',
        'Challan / Trial, if any',
        'Evidence / Financial Trail',
        'Arguments',
        'Order / Judgment',
        'Appeal / Writ / De-Freezing / Further Remedy',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Anti-Money Laundering / Financial Crime Wing', description: 'Primary FIA forum for AML/financial crime inquiry and investigation where FIA is involved.', isRecommended: true },
        { label: 'Special Court / AML Court', description: 'Use for AML challan/trial where assigned.', isRecommended: false },
        { label: 'Bank / Financial Institution / Regulator', description: 'Use where account freezing, STR, or bank/regulator process is relevant.', isRecommended: false },
        { label: 'High Court', description: 'Use for bail, de-freezing challenge, writ, or constitutional challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'AML forum depends on predicate offence, financial trail, account freezing, FIR/challan status, special court assignment, and maintainability.',
      documentTabs: [
        'AML Complaint / Defence',
        'Financial Record',
        'Freezing / Attachment Record',
        'Predicate Offence Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Challan / Trial',
      label: 'FIA Challan / Trial',
      shortLabel: 'Challan / Trial',
      description: 'Trial proceedings after FIA FIR/challan before competent criminal, special, cybercrime, AML, trafficking, immigration, passport, or federal offence court.',
      legalBasis: [
        'CrPC trial/challan procedure where applicable.',
        'PECA 2016 for cybercrime trials.',
        'AMLA 2010 for AML trials.',
        'Trafficking/smuggling, passport, immigration, and other special laws depending offence.',
        'Qanun-e-Shahadat principles for evidence where applicable.'
      ],
      subtypes: [
        'FIA Challan',
        'PECA / Cybercrime Trial',
        'Electronic Fraud Trial',
        'Human Trafficking Trial',
        'Migrant Smuggling Trial',
        'Passport / Immigration Trial',
        'AML Trial',
        'Anti-Corruption / Federal Offence Trial',
        'Supplementary Challan',
        'Other FIA Trial'
      ],
      sideOptions: ['Accused', 'Co-Accused', 'Complainant', 'FIA / Prosecution', 'Witness', 'Affected Person'],
      defaultStages: [
        'Challan Submitted',
        'Court Appearance / Summons / Warrants',
        'Supply of Documents',
        'Charge / Notice',
        'Prosecution Evidence',
        'Cross-Examination',
        'Statement of Accused',
        'Defence Evidence, if any',
        'Final Arguments',
        'Judgment',
        'Sentence / Acquittal',
        'Appeal / Bail / Suspension, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'Special Court / FIA Court', description: 'Common forum for FIA/federal offence trials where assigned.', isRecommended: true },
        { label: 'Special Court / Cybercrime Court', description: 'Use for PECA/cybercrime trial where assigned.', isRecommended: false },
        { label: 'Special Court / AML Court', description: 'Use for AML trial where assigned.', isRecommended: false },
        { label: 'Special Court / Immigration / Passport Court', description: 'Use for passport/immigration offence trial where assigned.', isRecommended: false },
        { label: 'Magistrate / Sessions Court', description: 'Use where ordinary criminal forum applies depending offence.', isRecommended: false },
        { label: 'High Court', description: 'Use for bail, appeal, revision, quashment, or constitutional challenge where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Trial forum depends on offence statute, challan, special court assignment, territorial jurisdiction, and applicable procedure.',
      documentTabs: [
        'Challan / Charge',
        'FIA Record',
        'Prosecution Evidence',
        'Defence Evidence',
        'Digital / Forensic Evidence',
        'Applications',
        'Orders & Judgments',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Bail',
      label: 'FIA Bail',
      shortLabel: 'Bail',
      description: 'Bail matters in FIA, cybercrime, AML, trafficking, immigration, passport, and federal offence cases, including pre-arrest bail, post-arrest bail, protective bail, bail after conviction, bail cancellation, and suspension of sentence.',
      legalBasis: [
        'CrPC bail provisions.',
        'PECA/AML/special law context depending offence.',
        'High Court/Sessions Court/special court bail jurisdiction may depend on offence, custody status, trial forum, and special law.',
        'Grounds may include further inquiry, no useful purpose of custody, delay, mala fide, evidence collected, health, compromise where applicable, and merits depending facts.'
      ],
      subtypes: [
        'Pre-Arrest Bail',
        'Post-Arrest Bail',
        'Protective Bail',
        'Bail in Cybercrime / PECA Case',
        'Bail in Electronic Fraud Case',
        'Bail in Trafficking / Smuggling Case',
        'Bail in Immigration / Passport Case',
        'Bail in AML Case',
        'Bail After Conviction',
        'Bail Cancellation',
        'Suspension of Sentence',
        'Other FIA Bail Matter'
      ],
      sideOptions: ['Accused / Applicant', 'FIA / Prosecution', 'Complainant', 'State', 'Respondent'],
      defaultStages: [
        'FIR / Arrest Risk Review',
        'Bail Petition Drafting',
        'Filing before Forum',
        'Interim / Protective Relief, if any',
        'Notice to FIA / State',
        'FIA Reply / Comments',
        'Record Produced / Called',
        'Arguments',
        'Bail Order',
        'Surety / Bonds / Release, if granted',
        'Confirmation / Dismissal / Disposal',
        'Further Remedy, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'Sessions Court', description: 'Common forum for pre-arrest/post-arrest bail depending offence and stage.', isRecommended: false },
        { label: 'High Court', description: 'Common forum for bail/protective bail, especially special law or constitutional/bail jurisdiction matters.', isRecommended: false },
        { label: 'Special Court / FIA Court', description: 'Use where bail is before special trial court.', isRecommended: false },
        { label: 'Special Court / Cybercrime Court', description: 'Use where PECA/cybercrime bail is before assigned court.', isRecommended: false },
        { label: 'Special Court / AML Court', description: 'Use where AML bail is before assigned court.', isRecommended: false },
        { label: 'Supreme Court', description: 'Use where further bail/appeal jurisdiction is invoked according to law.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'FIA bail forum depends on offence type, custody status, FIR/challan stage, special court assignment, and current maintainability.',
      documentTabs: [
        'Bail Petition',
        'FIR / FIA Record',
        'Digital / Financial / Travel Record',
        'Medical / Personal Grounds',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Remand / Custody Matter',
      label: 'Remand / Custody Matter',
      shortLabel: 'Remand',
      description: 'Matters relating to physical remand, judicial remand, custody, production before court, remand extension, custody challenge, device/data recovery, and remand-related FIA proceedings.',
      legalBasis: [
        'CrPC remand/custody provisions.',
        'Special law requirements depending offence.',
        'Device/data recovery and forensic examination may be relevant in cybercrime/electronic fraud matters.'
      ],
      subtypes: [
        'Physical Remand',
        'Judicial Remand',
        'Extension of Remand',
        'Challenge to Remand',
        'Production Order',
        'Medical Examination during Custody',
        'Device / Data Recovery during Remand',
        'Custody Transfer',
        'Other Remand / Custody Matter'
      ],
      sideOptions: ['Accused', 'FIA / Prosecution', 'Applicant', 'Respondent', 'Family Member / Representative'],
      defaultStages: [
        'Arrest / Custody Review',
        'Production before Court',
        'FIA Remand Request',
        'Defence Opposition to Remand',
        'Physical Remand Granted / Refused',
        'Device / Data / Recovery Proceedings, if any',
        'Extension Request, if any',
        'Judicial Remand',
        'Medical / Welfare Application, if any',
        'Bail / Challenge to Remand, if any',
        'Further Production / Challan Stage',
        'Closed'
      ],
      forumOptions: [
        { label: 'Magistrate / Special Magistrate', description: 'Common forum for remand/production where applicable.', isRecommended: true },
        { label: 'Special Court / FIA Court', description: 'Use where remand/custody issue is before special court.', isRecommended: false },
        { label: 'Special Court / Cybercrime Court', description: 'Use where cybercrime remand/custody issue is assigned to special court.', isRecommended: false },
        { label: 'High Court / Constitutional Jurisdiction', description: 'Use where custody/remand/arrest is challenged where maintainable.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Remand forum depends on arrest, production, offence type, investigation need, device/data recovery, and legality of custody.',
      documentTabs: [
        'Remand Application / Order',
        'Arrest / Custody Record',
        'Device / Recovery Record',
        'Medical / Welfare Record',
        'Applications',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Appeal',
      label: 'FIA Appeal',
      shortLabel: 'Appeal',
      description: 'Appeal against judgment, conviction, acquittal, sentence, final order, bail order, cybercrime order, AML order, passport/immigration order, trafficking/smuggling order, or other FIA-related order where maintainable.',
      legalBasis: [
        'CrPC appeal provisions where applicable.',
        'PECA/AML/passport/trafficking/immigration special law appeal provisions where applicable.',
        'Appeal forum and limitation depend on impugned order and applicable law.'
      ],
      subtypes: [
        'Appeal Against Conviction',
        'Appeal Against Acquittal',
        'Appeal Against Sentence',
        'Appeal Against Final Judgment',
        'Appeal in PECA / Cybercrime Case',
        'Appeal in AML Case',
        'Appeal in Trafficking / Smuggling Case',
        'Appeal in Passport / Immigration Case',
        'Appeal by FIA / Prosecution',
        'Appeal by Accused',
        'Other FIA Appeal'
      ],
      sideOptions: ['Appellant', 'Respondent', 'Accused', 'FIA / Prosecution', 'Complainant', 'Affected Person'],
      defaultStages: [
        'Impugned Judgment / Order Review',
        'Certified Copies Awaited',
        'Memo of Appeal Drafting',
        'Filing',
        'Office Objections / Scrutiny',
        'Preliminary Hearing / Admission',
        'Notice to Respondent / FIA',
        'Record Summoned / Received',
        'Suspension of Sentence / Bail / Stay, if any',
        'Arguments',
        'Judgment / Final Order',
        'Further Remedy, if any',
        'Closed'
      ],
      forumOptions: [
        { label: 'Sessions Court', description: 'Use where appeal lies before Sessions Court depending trial forum/order.', isRecommended: false },
        { label: 'High Court', description: 'Common forum for criminal/special-law appeals where maintainable.', isRecommended: true },
        { label: 'Special Appellate Forum', description: 'Use where applicable special law provides a specific appellate forum.', isRecommended: false },
        { label: 'Supreme Court', description: 'Use where further appeal/special jurisdiction is invoked according to law.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'FIA appeal forum depends on trial forum, offence statute, impugned order, limitation, and special law.',
      documentTabs: [
        'Memo of Appeal',
        'Applications',
        'Impugned Judgment / Order',
        'Trial / FIA Record',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Revision / Constitutional Challenge',
      label: 'FIA Revision / Constitutional Challenge',
      shortLabel: 'Revision / Writ',
      description: 'Revision, writ, constitutional petition, or challenge against FIA notice, inquiry, investigation, FIR, arrest, remand, seizure, cybercrime complaint, travel restriction, freezing order, challan, or trial court order where maintainable.',
      legalBasis: [
        'Constitutional jurisdiction where maintainable.',
        'CrPC quashment/revisional context where applicable.',
        'PECA/AML/immigration/special law remedy may affect maintainability.',
        'Maintainability depends on alternate remedy, stage of proceedings, jurisdictional defect, mala fide, fair process, and nature of impugned action.'
      ],
      subtypes: [
        'Writ Against FIA Notice',
        'Writ Against FIA Inquiry',
        'Writ Against FIA Investigation',
        'Quashing of FIA FIR',
        'Challenge to FIA Arrest',
        'Challenge to Device / Data Seizure',
        'Challenge to Cybercrime Complaint',
        'Challenge to ECL / PNIL / Travel Restriction',
        'Challenge to Bank Account Freezing',
        'Challenge to FIA Challan / Trial',
        'Challenge to Jurisdiction',
        'Other FIA Constitutional Challenge'
      ],
      sideOptions: ['Petitioner', 'Respondent', 'Accused', 'FIA / Prosecution', 'Complainant', 'Affected Person', 'Applicant'],
      defaultStages: [
        'Impugned FIA Action / Order Review',
        'Maintainability / Alternate Remedy Review',
        'Petition Drafting',
        'Filing',
        'Office Objections / Scrutiny',
        'Preliminary Hearing / Admission',
        'Notice to FIA / Respondents',
        'Comments / Report',
        'Rejoinder, if any',
        'Interim Relief / Stay, if any',
        'Arguments',
        'Final Order',
        'Compliance / Further Remedy',
        'Closed'
      ],
      forumOptions: [
        { label: 'High Court / Constitutional Jurisdiction', description: 'Common forum for writ/constitutional challenge against FIA action where maintainable.', isRecommended: true },
        { label: 'High Court', description: 'Use where challenge is connected with bail, appeal, quashment, or special law matter.', isRecommended: false },
        { label: 'Sessions Court', description: 'Use where revision/remedy lies before Sessions Court depending order and law.', isRecommended: false },
        { label: 'Supreme Court', description: 'Use where further constitutional/appellate jurisdiction is invoked according to law.', isRecommended: false },
        { label: 'Trial / Special Court', description: 'Use where issue should first be raised before trial/special court.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'FIA writ/challenge maintainability depends on alternate remedy, stage of proceedings, jurisdiction, mala fide, fair process, and impugned action/order.',
      documentTabs: [
        'Writ / Challenge Petition',
        'FIA Record',
        'Applications',
        'Impugned Notice / FIR / Order',
        'Digital / Financial / Travel Record',
        'Replies / Comments',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'FIA Miscellaneous Application',
      label: 'FIA Miscellaneous Application',
      shortLabel: 'Application',
      description: 'Connected or standalone applications in FIA/cybercrime/federal offence proceedings, including exemption, recall, production of record, device/data release, de-freezing, medical examination, transfer, stay, condonation, certified copies, and early hearing.',
      legalBasis: [
        'Use FIA Act / PECA / AMLA / CrPC / QSO / special law context where applicable.',
        'Avoid absolute section references unless configured by exact subtype.'
      ],
      subtypes: [
        'Exemption from Appearance',
        'Application for Recall of Witness',
        'Application for Production of Record',
        'Application for Return of Device / Data',
        'Application for De-Freezing / Release of Bank Account',
        'Application for Medical Examination',
        'Application for Transfer of Case',
        'Application for Stay',
        'Application for Condonation of Delay',
        'Application for Early Hearing',
        'Application for Certified Copies',
        'Other FIA Application'
      ],
      sideOptions: ['Applicant', 'Respondent', 'Accused', 'FIA / Prosecution', 'Complainant', 'Affected Person', 'Third-Party Claimant'],
      defaultStages: [
        'Application Preparation',
        'Filing',
        'Scrutiny / Objections, if any',
        'Notice to Respondent / FIA, if required',
        'Reply / Objections',
        'Record / Report Called, if required',
        'Hearing / Arguments',
        'Order',
        'Compliance / Main Case Linkage',
        'Closed'
      ],
      forumOptions: [
        { label: 'Same Trial / Special Court Where Case Is Pending', description: 'For applications connected with pending FIA challan/trial.', isRecommended: true },
        { label: 'FIA Regional Office / Circle', description: 'For applications/representations connected with inquiry/investigation.', isRecommended: false },
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: 'For device/data/cybercrime-related applications at inquiry/investigation stage.', isRecommended: false },
        { label: 'High Court', description: 'For applications connected with bail, appeal, writ, or challenge.', isRecommended: false },
        { label: 'Other / Custom Forum', description: 'Use if forum differs.', isRecommended: false }
      ],
      forumHelper: 'Application forum depends on main FIA matter, pending forum, stage of proceedings, and nature of relief.',
      documentTabs: [
        'Application',
        'Reply / Objections',
        'Supporting Documents',
        'FIA / Court Record',
        'Digital / Financial / Travel Record',
        'Orders',
        'Miscellaneous'
      ]
    },
    {
      id: 'Other FIA / Federal Offence Matter',
      label: 'Other FIA / Federal Offence Matter',
      shortLabel: 'Other FIA',
      description: 'Use this for FIA, cybercrime, AML, immigration, passport, trafficking, federal investigation, or federal offence matters that do not fit the available FIA case types.',
      legalBasis: [],
      subtypes: [
        'Custom FIA Matter',
        'Custom Cybercrime Matter',
        'Custom Federal Offence Matter',
        'Other'
      ],
      sideOptions: ['Party A', 'Party B', 'Accused', 'FIA / Prosecution', 'Complainant', 'Applicant', 'Respondent', 'Affected Person'],
      defaultStages: [
        'Case Preparation / Record Review',
        'Notice / Inquiry / Filing, if applicable',
        'Reply / Response',
        'Proceedings / Hearing',
        'Record / Evidence',
        'Arguments',
        'Order / Judgment',
        'Compliance / Further Remedy',
        'Closed'
      ],
      forumOptions: [
        { label: 'FIA Regional Office / Circle', description: '', isRecommended: false },
        { label: 'FIA Cyber Crime Wing / Reporting Centre', description: '', isRecommended: false },
        { label: 'FIA Immigration Wing', description: '', isRecommended: false },
        { label: 'FIA Anti-Money Laundering / Financial Crime Wing', description: '', isRecommended: false },
        { label: 'FIA Anti-Human Trafficking Circle', description: '', isRecommended: false },
        { label: 'Special Court / FIA Court', description: '', isRecommended: false },
        { label: 'Sessions Court', description: '', isRecommended: false },
        { label: 'High Court', description: '', isRecommended: false },
        { label: 'Supreme Court', description: '', isRecommended: false },
        { label: 'High Court / Constitutional Jurisdiction', description: '', isRecommended: false },
        { label: 'Other / Custom Forum', description: '', isRecommended: false }
      ],
      forumHelper: '',
      documentTabs: [
        'Documents',
        'Applications',
        'FIA Record',
        'Digital / Financial / Travel Record',
        'Orders',
        'Miscellaneous'
      ]
    }
  ]
};

export const normalizeFiaCaseClassification = (existingCase: any) => {
  if (existingCase.caseCategory === 'FIA / Cybercrime / Federal Offences' || existingCase.caseCategory === 'FIA') {
    return { ...existingCase, caseCategory: 'FIA / Cybercrime / Federal Offences' };
  }

  let type = existingCase.matterType || existingCase.caseTypeName || existingCase.caseType || '';
  let subtype = existingCase.caseSubtype || '';
  type = type.trim();
  subtype = subtype.trim();
  const lowerType = type.toLowerCase();

  const mapping: any = {
    'fia case': ['Other FIA / Federal Offence Matter'],
    'federal offence case': ['Other FIA / Federal Offence Matter'],
    
    'fia inquiry': ['FIA Inquiry / Notice Matter'],
    'fia notice': ['FIA Inquiry / Notice Matter', 'FIA Notice'],
    'fia summons': ['FIA Inquiry / Notice Matter', 'Summons / Appearance Notice'],
    'fia document notice': ['FIA Inquiry / Notice Matter', 'Document Production Notice'],
    
    'fia investigation': ['FIA Investigation Matter'],
    'fia arrest apprehension': ['FIA Investigation Matter', 'Arrest Apprehension'],
    'fia device seizure': ['FIA Investigation Matter', 'Device / Data Seizure'],

    'cybercrime case': ['Cybercrime / PECA Matter'],
    'peca case': ['Cybercrime / PECA Matter'],
    'cyber harassment': ['Cybercrime / PECA Matter', 'Cyber Harassment'],
    'cyberstalking': ['Cybercrime / PECA Matter', 'Cyberstalking'],
    'hacking': ['Cybercrime / PECA Matter', 'Unauthorized Access / Hacking'],
    'online defamation': ['Cybercrime / PECA Matter', 'Online Defamation / Reputation Harm'],
    'identity misuse': ['Cybercrime / PECA Matter', 'Identity Misuse / Impersonation'],

    'electronic fraud': ['Electronic Fraud / Financial Cybercrime'],
    'online banking fraud': ['Electronic Fraud / Financial Cybercrime', 'Online Banking Fraud'],
    'credit card fraud': ['Electronic Fraud / Financial Cybercrime', 'Debit / Credit Card Fraud'],
    'otp fraud': ['Electronic Fraud / Financial Cybercrime', 'Phishing / OTP Fraud'],
    'mobile wallet fraud': ['Electronic Fraud / Financial Cybercrime', 'Mobile Wallet / Easypaisa / JazzCash Fraud'],
    'e-commerce fraud': ['Electronic Fraud / Financial Cybercrime', 'E-Commerce Fraud'],

    'human trafficking': ['Human Trafficking / Migrant Smuggling Matter', 'Human Trafficking'],
    'migrant smuggling': ['Human Trafficking / Migrant Smuggling Matter', 'Migrant Smuggling'],
    'travel agent fraud': ['Human Trafficking / Migrant Smuggling Matter', 'Travel Agent Fraud'],
    'forged travel documents': ['Human Trafficking / Migrant Smuggling Matter', 'Forged Travel Documents'],

    'passport case': ['Immigration / Passport / Exit Control Matter'],
    'immigration case': ['Immigration / Passport / Exit Control Matter'],
    'ecl case': ['Immigration / Passport / Exit Control Matter', 'Exit Control List / ECL'],
    'pnil case': ['Immigration / Passport / Exit Control Matter', 'Provisional National Identification List / PNIL'],
    'airport offloading': ['Immigration / Passport / Exit Control Matter', 'Airport Offloading / Interception'],
    'blacklisting': ['Immigration / Passport / Exit Control Matter', 'Blacklisting / Travel Restriction'],

    'aml case': ['Anti-Money Laundering Matter'],
    'money laundering case': ['Anti-Money Laundering Matter'],
    'bank account freezing aml': ['Anti-Money Laundering Matter', 'Bank Account Freezing'],
    'proceeds of crime': ['Anti-Money Laundering Matter', 'Proceeds of Crime Allegation'],

    'fia challan': ['FIA Challan / Trial'],
    'fia trial': ['FIA Challan / Trial'],
    'peca trial': ['FIA Challan / Trial', 'PECA / Cybercrime Trial'],
    'aml trial': ['FIA Challan / Trial', 'AML Trial'],

    'fia bail': ['FIA Bail'],
    'fia pre-arrest bail': ['FIA Bail', 'Pre-Arrest Bail'],
    'fia post-arrest bail': ['FIA Bail', 'Post-Arrest Bail'],
    'peca bail': ['FIA Bail', 'Bail in Cybercrime / PECA Case'],
    'aml bail': ['FIA Bail', 'Bail in AML Case'],

    'fia remand': ['Remand / Custody Matter'],
    'physical remand fia': ['Remand / Custody Matter', 'Physical Remand'],
    'judicial remand fia': ['Remand / Custody Matter', 'Judicial Remand'],

    'fia appeal': ['FIA Appeal'],
    'appeal in peca case': ['FIA Appeal', 'Appeal in PECA / Cybercrime Case'],
    'appeal in aml case': ['FIA Appeal', 'Appeal in AML Case'],

    'fia writ': ['FIA Revision / Constitutional Challenge'],
    'writ against fia': ['FIA Revision / Constitutional Challenge'],
    'quashing of fia fir': ['FIA Revision / Constitutional Challenge', 'Quashing of FIA FIR'],
    'challenge to fia notice': ['FIA Revision / Constitutional Challenge', 'Writ Against FIA Notice'],
    'challenge to ecl': ['FIA Revision / Constitutional Challenge', 'Challenge to ECL / PNIL / Travel Restriction'],
    'challenge to seized device': ['FIA Revision / Constitutional Challenge', 'Challenge to Device / Data Seizure'],

    'fia miscellaneous application': ['FIA Miscellaneous Application'],
    'return of device application': ['FIA Miscellaneous Application', 'Application for Return of Device / Data'],
    'de-freezing application fia': ['FIA Miscellaneous Application', 'Application for De-Freezing / Release of Bank Account'],
    'exemption in fia case': ['FIA Miscellaneous Application', 'Exemption from Appearance']
  };

  const mapResult = mapping[lowerType];

  if (mapResult) {
    return {
      ...existingCase,
      caseCategory: 'FIA / Cybercrime / Federal Offences',
      caseType: mapResult[0],
      caseSubtype: mapResult.length > 1 ? mapResult[1] : subtype,
      legacyCaseType: type
    };
  }

  // If already tagged as FIA but not caught above, normalize category string
  if (lowerType.includes('fia') || lowerType.includes('cybercrime') || lowerType.includes('peca') || lowerType.includes('immigration') || lowerType.includes('money laundering') || lowerType.includes('ecl')) {
     return {
      ...existingCase,
      caseCategory: 'FIA / Cybercrime / Federal Offences',
      caseType: 'Other FIA / Federal Offence Matter',
      caseSubtype: subtype,
      legacyCaseType: type
    };
  }

  return existingCase;
};
